import { IQRAStateAndAssessmentCommonAttributes } from 'features/RiskManagement/Assessments'

interface ISavedStateInfoHeaderText {
  stateOrAssessment?: IQRAStateAndAssessmentCommonAttributes
}

/**
 * State creation date and author info display
 * If assessment id is provided, display info of relevent the nested
 * assessment instead (if found)
 * @param param0 state and assessment id parameters
 * @returns state info text DOM element
 */
export const SavedStateInfoHeaderText = ({
  stateOrAssessment
}: ISavedStateInfoHeaderText) => {
  return (
    <div className='mr-2 text-sm'>
      <span>Saved </span>
      <span>
        {stateOrAssessment?.dateCreated != null
          ? new Date(stateOrAssessment.dateCreated).toDateString()
          : 'on unknown date'}
      </span>
      <span> by </span>
      <span>{stateOrAssessment?.author}</span>
    </div>
  )
}
